import { profileUrl, incentivesUrl, towerUrl, helpCenterUrl, badgesUrl, marketplaceUrl, learningUrl, celebrationMomentsUrl, reportsUrl, advisorUrl, tasksUrl, activityFeedUrl, scormPlayerUrl, resourceCenterUrl, nominationsUrl } from 'endpoints';
export default [
    {
        name: 'profile',
        url: profileUrl,
        identity: 'profile'
    },
    {
        name: 'incentives',
        url: incentivesUrl,
        identity: 'incentives'
    },
    {
        name: 'home',
        url: towerUrl,
        identity: 'home'
    },
    {
        name: 'help_center',
        url: helpCenterUrl,
        identity: 'help-center'
    },
    {
        name: 'badges',
        url: badgesUrl,
        identity: 'badges-webapp'
    },
    {
        name: 'marketplace',
        url: marketplaceUrl,
        identity: 'marketplace'
    },
    {
        name: 'learning',
        url: learningUrl,
        identity: 'learning'
    },
    {
        name: 'celebration_moments',
        url: celebrationMomentsUrl,
        identity: 'celebration-moments'
    },
    {
        name: 'reports',
        url: reportsUrl,
        identity: 'reports'
    },
    {
        name: 'elevateAdvisor',
        url: advisorUrl,
        identity: 'elevate-advisor'
    },
    {
        name: 'tasks',
        url: tasksUrl,
        identity: 'tasks-webapp'
    },
    {
        name: 'activity_feed',
        url: activityFeedUrl,
        identity: 'activity-feed'
    },
    {
        name: 'scormPlayerWebapp',
        url: scormPlayerUrl,
        identity: 'scorm-player'
    },
    {
        name: 'resource_center',
        url: resourceCenterUrl,
        identity: 'resource-center'
    },
    {
        name: 'nominations',
        url: nominationsUrl,
        identity: 'nominations'
    },
];
